import { render, staticRenderFns } from "./IndividualCard.vue?vue&type=template&id=7ad24346&"
import script from "./IndividualCard.vue?vue&type=script&lang=js&"
export * from "./IndividualCard.vue?vue&type=script&lang=js&"
import style0 from "./IndividualCard.vue?vue&type=style&index=0&id=7ad24346&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports